//CSS
import '../../Components/Page/Page.css';

//React

import { useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Header2 from "../../Components/Header2/Header2";
import Footer from "../../Components/Footer/FooterSmall";
import { useUser } from '../../Context/UserContext';


const InvestorProtected: React.FC = () => {

    const { user, hasPermission } = useUser();

    const navigate = useNavigate();


    // if (!user) {
    //     return <div>User does not have permission</div>;
    // }

    useEffect(() => {
        // Redirect if not admin
        if (!hasPermission("investor.Protected")) {
            navigate('/need-permission');
            return;
        }
    }, [user?.roles, navigate]);

    return (
        <div className='generalPage'>
            <Header2 />
            <div className='pageContainer'>
                {/* <TheProblem />
                <OurSolution /> */}
                {/* <PDFDisplay /> */}
                {/* <MarketOpportunity />
                <BusinessModel/>
                <Milestones/>
                <GoToMarket/>
                <Competition/>
                <FundingI/>
                <FundingII/> */}
                <div className="needPermission">
                    <h2>
                        More information coming soon
                    </h2>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default InvestorProtected;